function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.19 16.78h1.49c1.09 0 1.94-.85 1.94-1.94v-1.49c0-1.09-.85-1.94-1.94-1.94H7.77c.08-1.81.5-2.08 1.71-2.79.36-.21.47-.67.26-1.03a.746.746 0 00-.65-.37c-.13 0-.26.03-.38.1-1.79 1.06-2.46 1.75-2.46 4.83v2.67c0 1.09.87 1.96 1.94 1.96zm6.13 0h1.49c1.09 0 1.94-.85 1.94-1.94v-1.49c0-1.09-.85-1.94-1.94-1.94H13.9c.08-1.81.5-2.08 1.71-2.79.36-.21.47-.67.26-1.03a.746.746 0 00-.65-.37c-.13 0-.26.03-.38.1-1.79 1.06-2.46 1.75-2.46 4.83v2.67c.01 1.09.88 1.96 1.94 1.96z"
})));